module.exports = __webpack_public_path__ + "img/bespoke123_15.1cd1a5b0.jpg";